import { Modal } from '@reverbdotcom/commons';
import I18n from 'i18n-js';
import React from 'react';
import { AddressSuggestionForm } from './AddressSuggestionForm';
import { gql } from '@reverbdotcom/commons/src/gql';
import { useQuery } from '@reverbdotcom/commons/src/useQuery';

interface Props {
  id: string;
  onModalClose: () => any;
}

export function AddressSuggestionModal({ id, onModalClose }: Props) {
  const { data } = useQuery(
    VERIFY_ADDRESS_QUERY,
    {
      variables: {
        input: {
          id: id,
        },
      },
      onError: onModalClose,
      onCompleted: (response) => {
        if (!response.addressVerify.recommendSuggestion) {
          onModalClose();
        }
      },
    },
  );
  const { recommendSuggestion, suggestion, address } = data?.addressVerify || {};

  return (
    <Modal
      isOpen={recommendSuggestion}
      paddedBody
      headerTitle={I18n.t('discovery.addressSuggestion.modal.header')}
      onRequestClose={onModalClose}
    >
      <AddressSuggestionForm
        address={address}
        onAddressUpdated={onModalClose}
        suggestion={suggestion}
      />
    </Modal>
  );
}

const VERIFY_ADDRESS_QUERY = gql(`
  query Core_Address_Verify(
    $input: Input_core_apimessages_AddressVerifyRequest
  ) {
    addressVerify(input: $input) {
      recommendSuggestion
      suggestion {
        streetAddress
        extendedAddress
        locality
        region
        postalCode
        countryCode
      }
      address {
        id
        streetAddress
        extendedAddress
        locality
        region
        postalCode
        countryCode
      }
    }
  }
`);
